import * as Enums from "@/enums/enums";
import { CheckIsDevelop, IsEnabledEWF } from "@/helper/shareHelper";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GlobalMixin extends Vue {
  public Enums = Enums;

  public get isEnabledEWF(): boolean {
    return IsEnabledEWF();
  }

  public get isDevelop(): boolean {
    return CheckIsDevelop();
  }
}
